
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "DescriptionInfoVideoBlock",

  data: function () {
    return {
      isPlay: false,
      isAnimate: false,
      windowWidth: null,
    }
  },

  mounted: function () {
    document.addEventListener('scroll', this.inFieldOfView);
    document.addEventListener('resize', this.handleWindowSize );
    this.handleWindowSize();
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
    document.removeEventListener('resize', this.handleWindowSize);
  },

  computed: {
    information: function () {
      return this.values?.information || []
    },
    description: function () {
      return this.values?.description || ''
    },
    isVideo: function () {
      return Boolean(this.extras?.video)
    },
    isInformation: function () {
      return Boolean(this.information.length > 0)
    },
    title: function () {
      return this.values?.title ? this.values?.title : 'Ролик о нашей компании'
    },
    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    },
    isMobile: function () {
      return this.windowWidth < 991;
    },
    videoHeight: function () {
      return this.isMobile ? 'auto' : 348;
    }
  },

  methods: {
    plainText: function (text) {
      return `${text || ''}`.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
    },
    onPlayVideo: function () {
      if (this.isPlay) {
        return
      }
      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.onPlayVideo();
        }, 500);
        return;
      }

      this.isPlay = true;
      if (this.$refs.refVideo.readyState === 0) { this.$refs.refVideo.load(); }
      const playPromise = this.$refs.refVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(() => {}); }
      this.$refs.refVideo.muted = false;
    },
    onPauseVideo: function () {
      this.$refs.refVideo.pause();
      this.$refs.refVideo.muted = true;
      this.isPlay = false;
    },
    inFieldOfView: function () {
      if (scrollWatcher('description-info-video-block')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
    handleWindowSize: function () {
      if (!process.client) {
        return false
      }
      this.windowWidth = window.innerWidth;
    },
  }
})
